export enum EnumCameraManufacturer {
  Selecione = 0,
  Intelbras = 1,
  Hikvision = 2,
  Tecvoz = 3,
}
